/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */
import { Avatar, Tooltip } from "@mantine/core";
import { ICellTextProps } from "ka-table/props";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import mantineRandomColor from "../../utils/MantineRandomColor";
import avatarGenerator, { resolveLogoSource } from "../../utils/avatarGenerator";

type RelatedAccountAvatarProps = {
  account: any;
  onClick: () => void;
};

const RelatedAccountAvatar = ({ account, onClick }: RelatedAccountAvatarProps) => {
  const [source, setSource] = useState(() => avatarGenerator({
    img: account["accounts.avatar_url"],
    desc: account["accounts.name"],
    size: 80,
  }));

  useEffect(() => {
    let isMounted = true;

    setSource(avatarGenerator({
      img: account["accounts.avatar_url"],
      desc: account["accounts.name"],
      size: 80,
    }));

    resolveLogoSource({
      img: account["accounts.avatar_url"],
      desc: account["accounts.name"],
      size: 80,
    }).then((resolvedSource) => {
      if (isMounted && resolvedSource) {
        setSource(resolvedSource);
      }
    }).catch(() => {
      // no-op
    });

    return () => {
      isMounted = false;
    };
  }, [account]);

  return (
    <Avatar
      onClick={onClick}
      size={32}
      className="hover:z-[2] hover:scale-125 cursor-pointer"
      src={source}
      radius="md"
      color={mantineRandomColor()}
    >
      {account["accounts.name"]?.charAt(0)}
    </Avatar>
  );
};

/**
 * Custom cell component.
 */
const RelatedAccountsCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const value = props.rowData[`${column.key}`];

    const navigate = useNavigate();
    return (
      <span className="whitespace-nowrap text-gray-500 w-full text-ellipsis overflow-hidden block">
        {" "}
        <Avatar.Group spacing="sm">
          {value?.length > 0 && value?.map((item: any) => (
            <Tooltip key={item["accounts.external_id"] || item["accounts.name"]} label={item["accounts.name"]}>
              <RelatedAccountAvatar
                account={item}
                onClick={() => {
                  navigate(`account/${item["accounts.external_id"]}/overview`);
                }}
              />
            </Tooltip>
          ))}
        </Avatar.Group>
      </span>
    );
  },
);
export default RelatedAccountsCell;
